module.exports = __webpack_public_path__ + "img/people.39a254ca.svg";